import { BrandingImage, DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import "./styles.css";

/**
 * @function ColumnAdWidget
 * @return {React.Component}
 * @exported true
 * @description An ad widget used in the "Account Summary" page.
 */
export default function ColumnAdWidget(props) {
  const navigate = useRoute();
  const brandingColorName = props.brandingColorName ?? "";
  const adURL = props.adURL ?? "";
  let hasAdURL = (adURL === "" || adURL === undefined) ? false : true;
  // The string needs to be of some type of url.
  if(!adURL.includes("http")) hasAdURL = false;
  let adURLIsInCurrABI22 = false;

  if(hasAdURL && adURL.includes("/bcms/click/abi22/")) {
    adURLIsInCurrABI22 = true;
  }

  // If the ad is enabled, then we will either route to a component or open a new window,
  // depending on if the url set in branding is in "/bcms/click/abi22/" or not.
  const onClick = () => {
    if(adURLIsInCurrABI22) {
      const urlHash = "#/";
      const indexOfURLHash = adURL.indexOf(urlHash);
      const route = "/" + adURL.substring(indexOfURLHash + urlHash.length);
      navigate(route);
    } else {
      window.open(adURL);
    }
  };
  
  return (
  <>
    { hasAdURL ?
    <div className="column-ad-widget flex-container flex-horizontal justify-center clickable show-on-desktop" onClick={ onClick }>
      <div data-point="Payments_Header">
        <BrandingImage dataPoint="Payments_Header" id={ brandingColorName } />
      </div>
    </div>
    :
    <DisabledPrompt>
      <div className="column-ad-widget flex-container flex-horizontal justify-center clickable show-on-desktop">
        <div data-point="Payments_Header">
          <BrandingImage dataPoint="Payments_Header" id={ brandingColorName } />
        </div>
      </div>
    </DisabledPrompt>
    }
  </>
  );
}